import { FileText, Upload, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export default function FilePreview({ file, onChange }) {
    const [preview, setPreview] = useState(null);
    const [fileType, setFileType] = useState(null);
    const objectUrlRef = useRef(null);



    const getTypeFromName = (name) => {
        if (!name) return null;
        if (/\.pdf$/i.test(name)) return "application/pdf";
        if (/\.(jpe?g|png|gif|webp)$/i.test(name)) return "image/jpeg";
        return null;
    };


    useEffect(() => {
        // If `value` is a File-like object, create object URL for preview
        if (file && typeof file !== "string") {
            // revoke old
            if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
            const objectUrl = URL.createObjectURL(file);
            objectUrlRef.current = objectUrl;
            setPreview(objectUrl);
            setFileType(file?.type || getTypeFromName(file?.name));
            return () => {
                if (objectUrlRef.current) {
                    URL.revokeObjectURL(objectUrlRef.current);
                    objectUrlRef.current = null;
                }
            };
        }

        // otherwise clear
        if (!file) {
            // revoke any local object URL
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
                objectUrlRef.current = null;
            }
            setPreview(null);
            setFileType(null);
        }
    }, [file]);


    const isImage = fileType?.startsWith("image/");
    const isPdf = fileType === "application/pdf" || /pdf/i.test(fileType);


    return (
        <>
            <div className="col-12 col-lg-12 mt-3">
                <div className="position-sticky" style={{ top: "96px" }}>
                    <div
                        className="card bg-dark text-light shadow-lg overflow-hidden"
                        style={{ height: "calc(100vh - 140px)" }}
                    >
                        {/* Header */}
                        <div className="card-header d-flex justify-content-between align-items-center bg-secondary border-bottom border-dark">
                            <div
                                className="d-flex align-items-center gap-2 text-light text-truncate"
                                style={{ maxWidth: "200px" }}
                            >
                                <FileText className="me-1" size={16} />
                                <span className="text-truncate">
                                    {file ? file?.name : "No Document Attached"}
                                </span>
                            </div>

                            {/* Upload Button */}
                            <label className="btn btn-sm btn-primary d-flex align-items-center gap-1 mb-0 cursor-pointer">
                                <Upload size={12} />
                                {file ? "Change File" : "Upload File"}
                                <input
                                    type="file"
                                    className="d-none"
                                    onChange={onChange}
                                />
                            </label>
                        </div>

                        {/* Document Viewer / Placeholder */}
                        <div className="flex-grow-1 overflow-auto bg-light d-flex align-items-center justify-content-center position-relative">
                            {file ? (
                                <>
                                    {/* Document Preview */}
                                    <div
                                        className="bg-white shadow p-4 border w-100 h-100"
                                        style={{ maxWidth: "80%", maxHeight: "90%" }}
                                    >
                                        {preview && (
                                            <div className="h-100 d-flex justify-content-center align-items-center position-relative">
                                                {isImage ? (
                                                    <img
                                                        src={preview}
                                                        alt="Preview"
                                                        className="img-fluid shadow-sm"
                                                        style={{ maxHeight: "400px", maxWidth: "100%" }}
                                                    />
                                                ) : isPdf ? (
                                                    // embed PDF using iframe/object - relies on browser's PDF viewer
                                                    <iframe
                                                        src={preview}
                                                        title="PDF preview"
                                                        style={{ width: "100%", height: "100%", border: "none" }}
                                                    />
                                                ) : (
                                                    <div className="d-flex flex-column justify-content-center align-items-center text-secondary">
                                                        <FileText size={48} className="mb-1 text-primary" />
                                                        <small className="text-truncate" style={{ maxWidth: "160px" }}>
                                                            {typeof value === "object" ? value.name : defaultUrl?.split("/").pop()}
                                                        </small>
                                                    </div>
                                                )}

                                                {/* <button
                                                    type="button"
                                                    // onClick={handleRemove}
                                                    className="position-absolute top-0 end-0 m-1 p-1 border-0"
                                                    style={{
                                                        backgroundColor: "#F56600",
                                                        color: "#fff",
                                                        width: "28px",
                                                        height: "28px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer",
                                                        borderRadius: "4px",
                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    title="Remove file"
                                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e05500")}
                                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F56600")}
                                                >
                                                    <X size={16} />
                                                </button> */}
                                            </div>
                                        )}
                                    </div>

                                    {/* Floating Label */}
                                    <div className="position-absolute custome_bottom start-50 translate-middle-x px-3 py-1 rounded-pill bg-dark bg-opacity-75 text-white small pointer-events-none mt custome">
                                        Document Preview
                                    </div>
                                </>
                            ) : (
                                <div className="text-center p-4">
                                    <div className="bg-secondary rounded-circle p-3 mb-3 d-inline-block">
                                        <FileText className="text-muted" size={32} />
                                    </div>
                                    <h5 className="text-dark fw-bold mb-1">
                                        No Document Uploaded
                                    </h5>
                                    <p
                                        className="text-muted small mx-auto"
                                        style={{ maxWidth: "250px" }}
                                    >
                                        You are in manual entry mode. You can still upload a
                                        POD or Rate sheet for reference using the button
                                        above.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}